import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PREFORM_FIELDS } from './validation/fields';
import AppInput from '../AppInput';
import ReCAPTCHA from '../ReCaptcha';
import Message from '../Message';
import { getValidateDni } from '../../../redux/actions/ValidationDniActions';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import MotiveTitle from '../../views/Contact/Motive/MotiveTitle';
import { resetGet } from '../../../redux/slices/ValidationDniSlice';
import { setRut } from '../../../redux/slices/IssuesSlice';
import { setIsValidReCaptcha } from '../../../redux/slices/reCaptchaSlice';
import { setAuthorized } from '../../../redux/slices/RoutesAuthSlice';
import { textMapper } from '../../../helpers/FormHelper';
import { UNLOCKED } from '../../../helpers/DniMessageHelper';
import LoadingButton from '../LoadingButton';
import { schema } from './validation/schema';
import { INSERT_DNI_DATA, DNI_NOT_VALID } from '../../../constants/texts';
import { usePreFormValidDniStyles } from './styles';
import DialogInfoDni from './DialogInfoDni';

const Form = ({ ...props }) => {
  const { state, onData, valid, mobile, motiveId, issueFormName } = props;
  const classes = usePreFormValidDniStyles({ mobile });
  const reduxDispatch = useDispatch();
  const history = useHistory();
  const { status, validationStatus, messageDniValid } = useSelector(
    (state) => state.validationDniSlice,
  );
  const { accordeonMotiveOpen } = useSelector(
    (state) => state.breadcrumbsSlice,
  );
  const { reCaptchaToken, isValidReCaptcha } = useSelector(
    (state) => state.reCaptchaSlice,
  );
  const [showOcCaptcha, setShowOcCaptcha] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });

    let fieldsValidate = schema.validate({ [e.target.name]: e.target.value });
    if ('error' in fieldsValidate) {
      setShowOcCaptcha(false);
      resetCaptcha();
    } else setShowOcCaptcha(true);
  };

  useEffect(() => {
    if (!valid) reduxDispatch(resetGet());
  }, [valid]);

  useEffect(() => {
    if (validationStatus === 'error') resetCaptcha();
  }, [validationStatus]);

  useEffect(() => {
    if (!mobile && status === UNLOCKED) {
      history.push(textMapper.get(accordeonMotiveOpen).redirect);
      reduxDispatch(setAuthorized(true));
    }
    if (mobile && status === UNLOCKED) {
      history.push(textMapper.get(motiveId).redirect);
      reduxDispatch(setAuthorized(true));
    }
  }, [status]);

  const rutForm = state.rut?.value;
  useEffect(() => {
    if (rutForm) reduxDispatch(setRut(rutForm));
  }, [rutForm]);

  const onClick = () => {
    const rut = state['rut'].value;
    const serie = state['serie'].value;
    if (valid) reduxDispatch(getValidateDni({ rut, serie, reCaptchaToken }));
  };

  const resetCaptcha = () => {
    reduxDispatch(setIsValidReCaptcha(false));
  };

  const clickOpenDialog = () => setOpenDialog(true);

  const handleClose = () => setOpenDialog(false);

  return (
    <React.Fragment>
      <DialogInfoDni
        mobile={mobile}
        open={openDialog}
        handleClose={handleClose}
      />

      {mobile && (
        <React.Fragment>
          <MotiveTitle
            icon={textMapper.get(motiveId).icon}
            title={textMapper.get(motiveId).title}
            subtitle={textMapper.get(motiveId).subtitle}
            mobile={mobile}
          />
          <Typography className={classes.title}>{INSERT_DNI_DATA}</Typography>
        </React.Fragment>
      )}
      {PREFORM_FIELDS.map((field, index) => (
        <AppInput
          key={index}
          issueFormName={issueFormName}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={clickOpenDialog}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          errorMessage={state[field.name]?.message || ''}
          info={state[field.name]?.info || false}
        />
      ))}
      {showOcCaptcha && validationStatus !== 'succeded' && (
        <React.Fragment>
          <ReCAPTCHA />
          <LoadingButton
            name="GetValidDni"
            onClick={onClick}
            variant="contained"
            color="primary"
            text="Consultar"
            disabled={!valid || !isValidReCaptcha}
          />
        </React.Fragment>
      )}
      {validationStatus === 'loading' && (
        <Box marginTop="26px" display="flex" justifyContent="center">
          <CircularProgress color="primary" />
        </Box>
      )}
      {(validationStatus === 'error' ||
        (validationStatus === 'success' && status !== UNLOCKED)) && (
        <Box marginTop="26px">
          <Message
            severity="alert"
            message={messageDniValid || DNI_NOT_VALID}
            fullRounded
          />
        </Box>
      )}
      {validationStatus === 'error' && (
        <Box marginTop="26px">
          <Message severity="alert" message={messageDniValid} fullRounded />
        </Box>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  valid: PropTypes.bool,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.string,
};

export default Form;
